import {Component, inject, Input, OnChanges} from '@angular/core';
import {PatientForVisit} from '../../../models/patient-for-visit';
import {FaModule} from '../fa/fa.module';
import {NgForOf} from '@angular/common';
import {ThemeModule} from '../../theme.module';
import {PatientActionsService} from '../../../portal/@portal-shared/hover-components/services/patient-actions.service';

@Component({
    selector: 'app-patient-census-warning',
    standalone: true,
    imports: [
        FaModule,
        NgForOf,
        ThemeModule,
    ],
    template: `
        <ng-template #patientCensusWarnings>
            @if (patient?.censusWarnings?.length) {
                <span [class]="containerClass">
                    <far *ngFor="let warning of patient.censusWarnings"
                         [ngbTooltip]="warning.text"
                         [i]="warning.icon"
                         class="smart-link smart-link-{{warning.level}} mx-0 cursor-pointer"
                         (click)="openCensusEdit(patient, $event)">
                    </far>
                </span>
            }
        </ng-template>
        @if (isTdTemplate) {
            <td>
                <ng-container *ngTemplateOutlet="patientCensusWarnings"></ng-container>
            </td>
        } @else {
            <ng-container *ngTemplateOutlet="patientCensusWarnings"></ng-container>
        }
  `,
    styles: [':host {display: contents}'],
})
export class PatientCensusWarningComponent implements OnChanges {
    @Input() patient: PatientForVisit;
    @Input() isTdTemplate = false;
    @Input() containerClass = '';

    patientActionService = inject(PatientActionsService);

    ngOnChanges() {
        if (this.patient && !(this.patient instanceof PatientForVisit)) {
            this.patient = new PatientForVisit(this.patient);
        }
    }

    openCensusEdit(patient: PatientForVisit, event: MouseEvent) {
        event.stopPropagation();
        this.patientActionService.editCensus(patient);
    }
}
